// src/utils/spaceTypes.js
//
// Space types and their colours, shared by the read-only overlay and the editor
// so the two can never drift apart.
//
// Hue encodes the FUNCTION FAMILY, so a traced plan reads as zones before any
// label is examined: warm = living, indigo = sleeping, teal/blue = wet,
// green = open to sky, grey = service, rose = ritual. Value separates spaces
// within a family.

export const SPACE_TYPES = [
  { key: 'living',    name: 'Living',    color: '#E9C28A', match: /living|hall|drawing|family|great/ },
  { key: 'dining',    name: 'Dining',    color: '#DEB585', match: /dining/ },
  { key: 'guest',     name: 'Guest Bed', color: '#B0ABDC', match: /guest/ },
  { key: 'bedroom',   name: 'Bedroom',   color: '#A3A2D4', match: /bed|master/ },
  { key: 'kitchen',   name: 'Kitchen',   color: '#72D9CD', match: /kitchen|pantry/ },
  { key: 'toilet',    name: 'Toilet',    color: '#8FC0D8', match: /toilet|bath|wc|powder/ },
  { key: 'utility',   name: 'Utility',   color: '#A2CDD9', match: /wash|utility|laundry/ },
  { key: 'balcony',   name: 'Balcony',   color: '#A0C99B', match: /balcon/ },
  // Terrace is tested BEFORE garden, and "open" is not a garden word. It was:
  // the sheet returned "OPEN DECK" and "OPEN TERRACE", and a greedy /open/
  // sitting above this rule painted both of them green as gardens.
  { key: 'terrace',   name: 'Terrace',   color: '#AED1A3', match: /terrace|deck/ },
  { key: 'garden',    name: 'Garden',    color: '#8BC68D', match: /garden|lawn|yard/ },
  { key: 'multi',     name: 'Multipurpose', color: '#D8BB8E', match: /multi[\s-]?purpose|study|office|family/ },
  { key: 'store',     name: 'Store',     color: '#A4B3CE', match: /store|storage/ },
  { key: 'staircase', name: 'Staircase', color: '#97A7C7', match: /stair|lift|elevator/ },
  { key: 'parking',   name: 'Parking',   color: '#A0ADCC', match: /park|garage|porch/ },
  { key: 'passage',   name: 'Passage',   color: '#B2BFD6', match: /passage|corridor|lobby|foyer|entry/ },
  { key: 'pooja',     name: 'Pooja',     color: '#D49DAC', match: /pooja|puja|prayer|mandir/ },
];

export const UNCLASSIFIED = '#7b879c';

/**
 * Match a free-text room label to a space type.
 *
 * Returns null when nothing matches, and callers must render that as visibly
 * unnamed rather than snapping it to the nearest bucket — a space the pipeline
 * could not identify has to look unidentified, or the user has no way to know
 * which labels to check.
 */
export function spaceOf(label) {
  const t = String(label || '').toLowerCase();
  if (!t) return null;
  return SPACE_TYPES.find((s) => s.match.test(t)) || null;
}

export function typeByKey(key) {
  return SPACE_TYPES.find((s) => s.key === key) || null;
}
